/*
 * File: /src/router/routes/aiContextTypes.js
 * Author: Roy Collins
 * -----
 * Copyright (c) 2026 AdBase, Inc.
 */

const AiContextTypeList = () =>
  import(
    /* webpackChunkName: "AiContextTypes" */ 'src/components/Dashboard/Views/AiContextTypes/AiContextTypeList.vue'
  );
const AiContextTypeEdit = () =>
  import(
    /* webpackChunkName: "AiContextTypes" */ 'src/components/Dashboard/Views/AiContextTypes/AiContextTypeEdit.vue'
  );

export const aiContextTypeRoutes = [
  {
    path: 'ai/context-types/list',
    name: 'AI Context Type List',
    component: AiContextTypeList,
  },
  {
    path: 'ai/context-types/add',
    name: 'AI Context Type Add',
    component: AiContextTypeEdit,
    props: () => ({
      id: undefined,
    }),
  },
  {
    path: 'ai/context-types/edit/:id',
    name: 'AI Context Type Edit',
    component: AiContextTypeEdit,
    props: (route) => ({
      id: parseInt(route.params.id),
    }),
  },
];
